const menuBtns = document.querySelectorAll(".header-nav__button");
const subMenus = document.querySelectorAll(".header-nav__sub");
const subGrids = document.querySelectorAll(".header-nav__sub-grid");
const overlay = document.querySelector(".nav-close-overlay");

// function to close all sub-menus
function closeAll(closeOverlay) {
    if (closeOverlay && !mobileNavOpen()) {
        overlay.classList.remove("active");
    }
    subMenus.forEach((menu) => {
        menu.classList.remove("active");
    });
    menuBtns.forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
    });
}

// check if any sub-menus are open
function isAnyOpen() {
    return (
        [...subMenus].some((menu) => menu.classList.contains("active"))
    );
}

// check if mobile nav is open
function mobileNavOpen() {
    return document.body.classList.contains("nav-active");
}

// toggle sub-menus on button click / focus
menuBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
        const thisSubMenu = btn.nextElementSibling;
        const isActive = thisSubMenu.classList.contains("active");
        const toggledCurrent = btn.getAttribute("aria-expanded") === "true";

        closeAll(toggledCurrent);

        if (!isActive) {
            overlay.classList.add("active");
            thisSubMenu.classList.add("active");
            btn.setAttribute("aria-expanded", "true");
        }
    });
});

// close all when last link in sub-menu loses focus, only if tabbing forward
let tabbingDirection = null;
subGrids.forEach((grid) => {
    const lastLink = grid.querySelector(".header-nav__sub-link:last-child");

    if (lastLink) {
        lastLink.addEventListener("keydown", (event) => {
            if (event.key === "Tab") {
                tabbingDirection = event.shiftKey ? 'backward' : 'forward';
            }
        });

        lastLink.addEventListener("blur", () => {
            if (tabbingDirection === 'forward') {
                closeAll(true);
            }
        });
    }
});

// close all on overlay click
overlay.addEventListener("click", () => {
    closeAll(true);
});

// close all when Escape key is pressed
document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isAnyOpen()) {
        closeAll(true);
    }
});
